import { setAuthToken } from "../../utils/setAuthToken";

const initialState = {
    isAuthenticated: false,
    decoded: null,
}
const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_USER":
            return {
                isAuthenticated: true,
                decoded: action.payload
            }
        case "LOGOUT_USER":
            localStorage.removeItem("authToken");
            setAuthToken();
            return {
                isAuthenticated: false,
                decoded: null
            }
        default:
            return state;
    }
};

export default authReducer;
